import React from 'react';

import { useLocation, useNavigationType, NavigationType } from 'react-router-dom';

export const ScrollToTop = () => {
	const location = useLocation();
	const navType = useNavigationType();

	React.useEffect(() => {
		if (navType === NavigationType.Pop) return;

		if (location.hash) {
			const el = document.querySelector(location.hash);
			if (el) {
				el.scrollIntoView({ block: 'start' });
				return;
			}
		}

		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}, [location.key, location.hash, navType]);

	return null;
};
